import React from 'react';

import { createRoot } from 'react-dom/client';
import { AppContainer } from 'src/apps/main/AppContainer';
import { initHubspotClient } from 'src/common/services/analytics/HubspotService';
import { initSentry } from 'src/common/services/SentryService';

import './index.css';

// Init hubspot
initHubspotClient();

// Init Sentry
initSentry();

// eslint-disable-next-line no-console
console.log(`Current UI Version is: ${UI_VERSION}`);

const container = document.getElementById('root');
if (!container) {
	throw new Error('Root element not found');
}
const root = createRoot(container);
root.render(<AppContainer />);
